/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const editUserResource = /* GraphQL */ `
  mutation EditUserResource(
    $editUserResourceRequestDto: EditUserResourceRequestDto!
  ) {
    editUserResource(editUserResourceRequestDto: $editUserResourceRequestDto) {
      status
      error
      userSuccessList
      userFailList
      errorMessage
      data
    }
  }
`;
export const editUserInfo = /* GraphQL */ `
  mutation EditUserInfo($editUserInfoRequestDto: EditUserInfoRequestDto!) {
    editUserInfo(editUserInfoRequestDto: $editUserInfoRequestDto) {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      lastName
      languages
      privilege
      type
      mail
      tel
      projectInuse
      creator
      createdAt
      updator
      updatedAt
      workSpace
      workLastForm
    }
  }
`;
export const editCorporation = /* GraphQL */ `
  mutation EditCorporation(
    $editCorporationRequestDto: EditCorporationRequestDto!
  ) {
    editCorporation(editCorporationRequestDto: $editCorporationRequestDto) {
      name
      image
      logoFileName
      limitValue
      corporationSetting
    }
  }
`;
export const saveTicketDraft = /* GraphQL */ `
  mutation SaveTicketDraft($createTicketRequestDto: CreateTicketRequestDto!) {
    saveTicketDraft(createTicketRequestDto: $createTicketRequestDto) {
      createTicketStatus
      errorMessage
      id
      affiliationOrganization
      outline
      description
      createdAt
      readPermission
      affiliationProject
      dataType
      dataLang
      liveOrArchived
      creator
      footPrint
      chatThreadData
    }
  }
`;
export const sendTicketFromDraft = /* GraphQL */ `
  mutation SendTicketFromDraft(
    $sendTicketFromDraftRequestDto: SendTicketFormDraftRequestDto!
  ) {
    sendTicketFromDraft(
      sendTicketFromDraftRequestDto: $sendTicketFromDraftRequestDto
    ) {
      createTicketStatus
      errorMessage
      id
      affiliationOrganization
      outline
      description
      createdAt
      readPermission
      affiliationProject
      dataType
      dataLang
      liveOrArchived
      creator
      footPrint
      chatThreadData
    }
  }
`;
export const createNewChatPost = /* GraphQL */ `
  mutation CreateNewChatPost(
    $createNewChatPostRequestDto: CreateNewChatPostRequestDto!
  ) {
    createNewChatPost(
      createNewChatPostRequestDto: $createNewChatPostRequestDto
    ) {
      contentId
      corporationId
      postType
      chatThreadId
      content
      creatorId
      delegateUserId
      createdAt
      fileUrl
      fileSize
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
    }
  }
`;
export const editForms = /* GraphQL */ `
  mutation EditForms($editFormRequestDto: EditFormsRequestDto!) {
    editForms(editFormRequestDto: $editFormRequestDto) {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      newShareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
    }
  }
`;
export const editCorporationDetail = /* GraphQL */ `
  mutation EditCorporationDetail(
    $editCorporationDetailRequestDto: EditCorporationDetailRequestDto!
  ) {
    editCorporationDetail(
      editCorporationDetailRequestDto: $editCorporationDetailRequestDto
    ) {
      id
      updateStatus
      errorCode
      errorList {
        maxNumOfGeneralUser
        maxNumOfAgent
        maxNumOfGuestUser
        maxNumOfCustomer
        maxNumOfGeneralProject
        maxNumOfGuestProject
        maxNumOfGuestDesk
        maxNumOfTicket
        maxNumOfStorage
      }
    }
  }
`;
export const updateFormFieldResource = /* GraphQL */ `
  mutation UpdateFormFieldResource(
    $updateFormFieldResourceRequestDto: UpdateFormFieldResourceRequestDto!
  ) {
    updateFormFieldResource(
      updateFormFieldResourceRequestDto: $updateFormFieldResourceRequestDto
    ) {
      status
      listFieldAddToFormResponse
      fieldListAddNew
      listFieldUpdateSharePermission
      fieldDataAddNew
      createFormResult
      updateFormResult
      fieldEditData
      fieldEditItemData
    }
  }
`;
export const translationUpdateApi = /* GraphQL */ `
  mutation TranslationUpdateApi(
    $translationUpdateApiRequestDto: TranslationUpdateApiRequestDto!
  ) {
    translationUpdateApi(
      translationUpdateApiRequestDto: $translationUpdateApiRequestDto
    ) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const createNewCorporation = /* GraphQL */ `
  mutation CreateNewCorporation(
    $id: String
    $active: Int
    $mailAddress: String!
    $userId: String!
    $firstName: String
    $lastName: String
    $corporationName: String
    $corporationPhone: String
    $departmentName: String
    $subDomain: String!
    $password: String!
    $contractType: String
    $inviter: String
    $userType: String
    $rootFlag: Int
    $owner: String
    $deskService: Int
    $knowledgeService: Int
    $taskManagementService: Int
    $publicService: Int
    $maxGeneralId: Int
    $maxGeneralUser: Int
    $productId: String
    $editionId: String
    $jobTitle: String
    $industry: String
    $companyName: String
  ) {
    createNewCorporation(
      id: $id
      active: $active
      mailAddress: $mailAddress
      userId: $userId
      firstName: $firstName
      lastName: $lastName
      corporationName: $corporationName
      corporationPhone: $corporationPhone
      departmentName: $departmentName
      subDomain: $subDomain
      password: $password
      contractType: $contractType
      inviter: $inviter
      userType: $userType
      rootFlag: $rootFlag
      owner: $owner
      deskService: $deskService
      knowledgeService: $knowledgeService
      taskManagementService: $taskManagementService
      publicService: $publicService
      maxGeneralId: $maxGeneralId
      maxGeneralUser: $maxGeneralUser
      productId: $productId
      editionId: $editionId
      jobTitle: $jobTitle
      industry: $industry
      companyName: $companyName
    ) {
      corporationInfo {
        id
        usage
        affiliationOrganization
        image
        logoFileName
        active
        name
        languages
        autoTranslation
        organizationDomain
        contractType
        contractDate
        lastDayOfContract
        creditCard
        ZIPcode
        address
        mail
        tel
        departmentName
        activatedFunctions
        limitValue {
          maxNumOfGeneralUser
          numOfGeneralUser
          maxNumOfAgent
          numOfAgent
          maxNumOfGuestUser
          numOfGuestUser
          maxNumOfCustomer
          numOfCustomer
          maxNumOfGeneralProject
          numOfGeneralProject
          maxNumOfGuestProject
          numOfGuestProject
          maxNumOfGuestDesk
          numOfGuestDesk
          numOfTicket
          maxNumOfTicket
          numOfStorage
          maxNumOfStorage
          numOfInternalUser
          numOfB2CCustomer
          numOfProjectDeskOn
          numOfProjectPublicOn
          numOfTicketKnowledge
          internalQACounterSettings
          publicWebForm
          emailResponseFunction
          knowledgeBot
          synonymSearch
          batchCommandService
          convertPDF
          chatAI
          usingChatAI
          lincenseKeyPermission
          lincenseKeySetting
          lincenseKeyValue
          chatGPTModel
          knnValue
          minScore
          aiAuto
          sdAuto
          telephoneAgent
          fileTranslation
          kBoard
          mcpServer
          multiLanguage
          systemPrompt
          interatorSystemPrompt
          usingAIAuto
          usingSDAuto
          usingTelephoneAgent
          usingFileTranslation
          usingKBoard
          usingMultiLanguage
          advancedOptionSettings
          logAnalysis
          ipRestriction
          maxNumOfTicketKnowledge
          maxNumberOfFormat
          maxNumberOfQACounters
          maxNumberOfSupportedCounters
          maxNumOfInternalUser
          maxNumOfB2CCustomer
          numberOfFormat
          numberOfQACounters
          numberOfSupportedCounters
          storageVolume
          generalUserFee
          basicCharge
          taskManagement
          vectorTicketDataStatus
          deskService
          knowledgeService
          publicService
          publicServiceDeskSettings
          solutionsDeskOfKnowledge
          publicKnowledgeSite
          numOfUserInOrg
          numOfPartnerId
          externalWebAPI
          numberOfExternalAPICalls
          maxNumberOfExternalAPICalls
          usingMultiAuth
          multiAuth
          localMcpEnabled
        }
        inviter
        inviterOrganizationDomain
        corporationInvited
        creator
        createdAt
        updator
        updatedAt
        rootFlag
        owner
        deskService
        knowledgeService
        taskManagementService
        publicService
        metaData
        versionId
        contractId
        contractStatus
      }
      userInfo {
        id
        usage
        affiliationOrganization
        image
        active
        firstName
        middleName
        lastName
        languages
        privilege
        type
        mail
        tel
        agent
        projectInuse
        readNotificationAt
        workSpace
        creator
        createdAt
        updator
        updatedAt
        expireAt
        forgotPasswordSessionExpireAt
        settingNotification
        isGuest
        userSetting
        mcpTunnelSetting
        mcpTunnelId
        projectRejected
        workLastForm
        organizationName
      }
      projectBaseInfo {
        id
        projectId
        usage
        affiliationOrganization
        image
        active
        name
        languages
        autoTranslation
        id2
        privilege
        type
        mail
        tel
        projectInvite
        projectInvited
        iframeSetting
        chatbotSetting
        isDesk
        isPublic
        isGuest
        publicKnowledgeSiteSetting
        projectAlias
        projectSetting
        mcpTunnelId
        chatBotCategorySetting
        mailSetting
        userLogCache
        managementPanel
        phoneAvailability
        lastUpdatePhoneAvailability
        creator
        createdAt
        updator
        updatedAt
      }
      initData {
        userId
        corporationId
        projectListId
      }
    }
  }
`;
export const createNewTicket = /* GraphQL */ `
  mutation CreateNewTicket($createTicketRequestDto: CreateTicketRequestDto!) {
    createNewTicket(createTicketRequestDto: $createTicketRequestDto) {
      createTicketStatus
      errorMessage
      id
      affiliationOrganization
      outline
      description
      createdAt
      readPermission
      affiliationProject
      dataType
      dataLang
      liveOrArchived
      creator
      footPrint
      chatThreadData
    }
  }
`;
export const createGuestContract = /* GraphQL */ `
  mutation CreateGuestContract(
    $guestContractRequestDto: CreateGuestContractRequestDto!
  ) {
    createGuestContract(guestContractRequestDto: $guestContractRequestDto) {
      corporationId
      createdAt
      status
      isCreateApprovePage
    }
  }
`;
export const editTicket = /* GraphQL */ `
  mutation EditTicket($updateTicketRequestDto: UpdateTicketRequestDto!) {
    editTicket(updateTicketRequestDto: $updateTicketRequestDto) {
      id
      corporationId
      usage
      updateStatus
      createdAt
      updatedAt
      anonymousQaStatus
      wasUpdatedBefore
      errorCode
      isNotiToCustomerDone
      isNotiToHelpDeskDone
      updatedChildrenTicketIdList
    }
  }
`;
export const createNewField = /* GraphQL */ `
  mutation CreateNewField(
    $fieldList: [CreateNewFieldRequestDto]!
    $type: String
  ) {
    createNewField(fieldList: $fieldList, type: $type) {
      field {
        id
        usage
        name
        affiliationOrganization
        affiliationProject
        affiliationField
        createdAt
        updatedAt
        creator
        updator
        type
        structure
        viewForCustomer
        definition
        explanation
        usingProjects
        usingTickets
        order
        relatedMasterForm
        settingAutoAdd
        shareOption
        shareRange
        viewPermission
        editPermission
        chatPermission
        reviewFlag
        promptKnowledgeFormFlag
        isSynonym
        definitionVariant
        isAllowCustomerChangeStatus
      }
      itemList {
        id
        usage
        name
        affiliationOrganization
        affiliationProject
        affiliationField
        createdAt
        updatedAt
        creator
        updator
        type
        structure
        viewForCustomer
        definition
        explanation
        usingProjects
        usingTickets
        order
        relatedMasterForm
        settingAutoAdd
        shareOption
        shareRange
        viewPermission
        editPermission
        chatPermission
        reviewFlag
        promptKnowledgeFormFlag
        isSynonym
        definitionVariant
        isAllowCustomerChangeStatus
      }
    }
  }
`;
export const createAnonymousQa = /* GraphQL */ `
  mutation CreateAnonymousQa(
    $createAnonymousQaRequestDto: CreateAnonymousQaRequestDto!
  ) {
    createAnonymousQa(
      createAnonymousQaRequestDto: $createAnonymousQaRequestDto
    ) {
      id
      affiliationOrganization
      outline
      description
      createdAt
      readPermission
      affiliationProject
      dataType
      dataLang
      liveOrArchived
      creator
      wasUpdatedBefore
      errorMessage
    }
  }
`;
export const addCustomerUserToProject = /* GraphQL */ `
  mutation AddCustomerUserToProject(
    $addCustomerUserToProjectRequestDto: AddCustomerUserToProjectRequestDto!
  ) {
    addCustomerUserToProject(
      addCustomerUserToProjectRequestDto: $addCustomerUserToProjectRequestDto
    ) {
      status
      successList {
        clientId
        id
        usage
        affiliationOrganization
        image
        active
        firstName
        middleName
        lastName
        languages
        privilege
        type
        mail
        tel
        projectInuse
        readNotificationAt
        creator
        createdAt
        updator
        updatedAt
      }
      errorList {
        clientId
        firstName
        lastName
        mail
        error
      }
    }
  }
`;
export const forgotPassword = /* GraphQL */ `
  mutation ForgotPassword(
    $forgotPasswordRequestDto: ForgotPasswordRequestDto!
  ) {
    forgotPassword(forgotPasswordRequestDto: $forgotPasswordRequestDto) {
      isSuccess
      messageCode
    }
  }
`;
export const restoreUser = /* GraphQL */ `
  mutation RestoreUser($restoreUserRequestDto: RestoreUserRequestDto!) {
    restoreUser(restoreUserRequestDto: $restoreUserRequestDto) {
      status
      errorMessage
    }
  }
`;
export const removeTicket = /* GraphQL */ `
  mutation RemoveTicket($removeTicketRequestDto: RemoveTicketRequestDto!) {
    removeTicket(removeTicketRequestDto: $removeTicketRequestDto) {
      status
      errorMessage
      removedChildrenTicketIdList
    }
  }
`;
export const blockAndDeleteOrganization = /* GraphQL */ `
  mutation BlockAndDeleteOrganization(
    $blockAndDeleteOrganizationRequestDto: BlockAndDeleteOrganizationRequestDto!
  ) {
    blockAndDeleteOrganization(
      blockAndDeleteOrganizationRequestDto: $blockAndDeleteOrganizationRequestDto
    ) {
      success
      data {
        id
        usage
        affiliationOrganization
        image
        logoFileName
        active
        name
        languages
        autoTranslation
        organizationDomain
        contractType
        contractDate
        lastDayOfContract
        creditCard
        ZIPcode
        address
        mail
        tel
        departmentName
        activatedFunctions
        limitValue {
          maxNumOfGeneralUser
          numOfGeneralUser
          maxNumOfAgent
          numOfAgent
          maxNumOfGuestUser
          numOfGuestUser
          maxNumOfCustomer
          numOfCustomer
          maxNumOfGeneralProject
          numOfGeneralProject
          maxNumOfGuestProject
          numOfGuestProject
          maxNumOfGuestDesk
          numOfGuestDesk
          numOfTicket
          maxNumOfTicket
          numOfStorage
          maxNumOfStorage
          numOfInternalUser
          numOfB2CCustomer
          numOfProjectDeskOn
          numOfProjectPublicOn
          numOfTicketKnowledge
          internalQACounterSettings
          publicWebForm
          emailResponseFunction
          knowledgeBot
          synonymSearch
          batchCommandService
          convertPDF
          chatAI
          usingChatAI
          lincenseKeyPermission
          lincenseKeySetting
          lincenseKeyValue
          chatGPTModel
          knnValue
          minScore
          aiAuto
          sdAuto
          telephoneAgent
          fileTranslation
          kBoard
          mcpServer
          multiLanguage
          systemPrompt
          interatorSystemPrompt
          usingAIAuto
          usingSDAuto
          usingTelephoneAgent
          usingFileTranslation
          usingKBoard
          usingMultiLanguage
          advancedOptionSettings
          logAnalysis
          ipRestriction
          maxNumOfTicketKnowledge
          maxNumberOfFormat
          maxNumberOfQACounters
          maxNumberOfSupportedCounters
          maxNumOfInternalUser
          maxNumOfB2CCustomer
          numberOfFormat
          numberOfQACounters
          numberOfSupportedCounters
          storageVolume
          generalUserFee
          basicCharge
          taskManagement
          vectorTicketDataStatus
          deskService
          knowledgeService
          publicService
          publicServiceDeskSettings
          solutionsDeskOfKnowledge
          publicKnowledgeSite
          numOfUserInOrg
          numOfPartnerId
          externalWebAPI
          numberOfExternalAPICalls
          maxNumberOfExternalAPICalls
          usingMultiAuth
          multiAuth
          localMcpEnabled
        }
        inviter
        inviterOrganizationDomain
        corporationInvited
        creator
        createdAt
        updator
        updatedAt
        rootFlag
        owner
        deskService
        knowledgeService
        taskManagementService
        publicService
        metaData
        versionId
        contractId
        contractStatus
        corporationSetting
        limitSetting
        translationCacheResetAt
      }
      errors
    }
  }
`;
export const updateProjectResource = /* GraphQL */ `
  mutation UpdateProjectResource(
    $updateProjectResourceRequestDto: UpdateProjectResourceRequestDto!
  ) {
    updateProjectResource(
      updateProjectResourceRequestDto: $updateProjectResourceRequestDto
    ) {
      status
      statusAddProject
      statusEditProject
      errorMessage
      data
    }
  }
`;
export const updateViewsResource = /* GraphQL */ `
  mutation UpdateViewsResource(
    $updateViewResourceRequestDto: UpdateViewResourceRequestDto!
  ) {
    updateViewsResource(
      updateViewResourceRequestDto: $updateViewResourceRequestDto
    ) {
      status
      errorMessage
      data
    }
  }
`;
export const updateApiPublic = /* GraphQL */ `
  mutation UpdateApiPublic($updateApiPublicRequestDto: String!) {
    updateApiPublic(updateApiPublicRequestDto: $updateApiPublicRequestDto) {
      success
      payload
      errors
    }
  }
`;
export const updateRootOrganizationPermission = /* GraphQL */ `
  mutation UpdateRootOrganizationPermission(
    $updateRootOrganizationPermissionRequestDto: UpdateRootOrganizationPermissionRequestDto!
  ) {
    updateRootOrganizationPermission(
      updateRootOrganizationPermissionRequestDto: $updateRootOrganizationPermissionRequestDto
    ) {
      id
      rootFlag
    }
  }
`;
export const createSupportChatPost = /* GraphQL */ `
  mutation CreateSupportChatPost($params: String!) {
    createSupportChatPost(params: $params) {
      id
      createdAt
      currentTime
    }
  }
`;
export const createTicketByUploadCsv = /* GraphQL */ `
  mutation CreateTicketByUploadCsv(
    $createTicketByUploadCsvRequestDto: CreateTicketByUploadCsvRequestDto!
  ) {
    createTicketByUploadCsv(
      createTicketByUploadCsvRequestDto: $createTicketByUploadCsvRequestDto
    ) {
      status
      id
      isSkipUpload
      errorMessage
      listTicket
    }
  }
`;
export const deleteUserLog = /* GraphQL */ `
  mutation DeleteUserLog($deleteUserLogRequestDto: DeleteUserLogRequestDto!) {
    deleteUserLog(deleteUserLogRequestDto: $deleteUserLogRequestDto) {
      status
    }
  }
`;
export const editProductManagement = /* GraphQL */ `
  mutation EditProductManagement(
    $editProductManagementRequestDto: EditProductManagementRequestDto!
  ) {
    editProductManagement(
      editProductManagementRequestDto: $editProductManagementRequestDto
    ) {
      status
      listProductErrors
      errorMessage
      listEditionErrors
      moduleSetting
    }
  }
`;
export const editCorporationContractDetail = /* GraphQL */ `
  mutation EditCorporationContractDetail(
    $editCorporationContractDetailRequestDto: EditCorporationContractDetailRequestDto!
  ) {
    editCorporationContractDetail(
      editCorporationContractDetailRequestDto: $editCorporationContractDetailRequestDto
    ) {
      status
      data
      errors
    }
  }
`;
export const createKibanaLog = /* GraphQL */ `
  mutation CreateKibanaLog($params: String!) {
    createKibanaLog(params: $params) {
      success
      payload
      errors
    }
  }
`;
export const sendAIChat = /* GraphQL */ `
  mutation SendAIChat($sendAIChatRequestDto: SendAIChatRequestDto!) {
    sendAIChat(sendAIChatRequestDto: $sendAIChatRequestDto) {
      responseMessage
      gptParams
    }
  }
`;
export const sendAIChatBot = /* GraphQL */ `
  mutation SendAIChatBot($sendAIChatBotRequestDto: SendAIChatBotRequestDto!) {
    sendAIChatBot(sendAIChatBotRequestDto: $sendAIChatBotRequestDto) {
      responseMessage
      gptParams
    }
  }
`;
export const updateAISettingsForKnowledgePrompt = /* GraphQL */ `
  mutation UpdateAISettingsForKnowledgePrompt(
    $updateAISettingsForKnowledgePromptRequestDto: UpdateAISettingsForKnowledgePromptRequestDto!
  ) {
    updateAISettingsForKnowledgePrompt(
      updateAISettingsForKnowledgePromptRequestDto: $updateAISettingsForKnowledgePromptRequestDto
    ) {
      status
      result
    }
  }
`;
export const publishOpenAIMessageStream = /* GraphQL */ `
  mutation PublishOpenAIMessageStream($params: SendMessageAIStreamRequestDto) {
    publishOpenAIMessageStream(params: $params) {
      message
      aiChatPostId
      seq
      isEnd
      postType
      isGeneratedFileError
    }
  }
`;
export const bulkUpdateTicket = /* GraphQL */ `
  mutation BulkUpdateTicket(
    $bulkUpdateTicketRequestDto: BulkUpdateTicketRequestDto!
  ) {
    bulkUpdateTicket(bulkUpdateTicketRequestDto: $bulkUpdateTicketRequestDto) {
      status
      taskId
      message
    }
  }
`;
export const testSifApi = /* GraphQL */ `
  mutation TestSifApi($testSifRequestDto: TestSifRequestDto!) {
    testSifApi(testSifRequestDto: $testSifRequestDto) {
      status
      body
    }
  }
`;
export const bookmarkUpdateAPI = /* GraphQL */ `
  mutation BookmarkUpdateAPI(
    $bookmarkUpdateAPIRequestDto: BookmarkUpdateAPIRequestDto!
  ) {
    bookmarkUpdateAPI(
      bookmarkUpdateAPIRequestDto: $bookmarkUpdateAPIRequestDto
    ) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const AiAutoLogUpdate = /* GraphQL */ `
  mutation AiAutoLogUpdate(
    $AiAutoLogUpdateRequestDto: AiAutoLogUpdateRequestDto!
  ) {
    AiAutoLogUpdate(AiAutoLogUpdateRequestDto: $AiAutoLogUpdateRequestDto) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const dataDownloadUploader = /* GraphQL */ `
  mutation DataDownloadUploader(
    $dataDownloadUploaderRequestDto: DataDownloadUploaderRequestDto!
  ) {
    dataDownloadUploader(
      dataDownloadUploaderRequestDto: $dataDownloadUploaderRequestDto
    ) {
      status
      message
      taskId
      downloadResponseDto {
        downloadFileUrl
      }
      uploadResponseDto {
        message
      }
    }
  }
`;
export const createThumbnail = /* GraphQL */ `
  mutation CreateThumbnail(
    $createThumbnailRequestDto: CreateThumbnailRequestDto!
  ) {
    createThumbnail(createThumbnailRequestDto: $createThumbnailRequestDto) {
      statusCode
      body
    }
  }
`;
export const mcpServerUpdate = /* GraphQL */ `
  mutation McpServerUpdate(
    $mcpServerUpdateRequestDto: MCPServerUpdateRequestDto!
  ) {
    mcpServerUpdate(mcpServerUpdateRequestDto: $mcpServerUpdateRequestDto) {
      success
      payload
      error
    }
  }
`;
export const twilioUpdate = /* GraphQL */ `
  mutation TwilioUpdate($twilioUpdateRequestDto: TwilioUpdateRequestDto!) {
    twilioUpdate(twilioUpdateRequestDto: $twilioUpdateRequestDto) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const openAIWebRTC = /* GraphQL */ `
  mutation OpenAIWebRTC($openAIWebRTCRequestDto: OpenAIWebRTCRequestDto!) {
    openAIWebRTC(openAIWebRTCRequestDto: $openAIWebRTCRequestDto) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const mcpBootstrap = /* GraphQL */ `
  mutation McpBootstrap($mcpBootstrapRequestDto: MCPBootstrapRequestDto!) {
    mcpBootstrap(mcpBootstrapRequestDto: $mcpBootstrapRequestDto) {
      status
      data
      errorMsg
      errorCode
    }
  }
`;
export const createAIChatPost = /* GraphQL */ `
  mutation CreateAIChatPost(
    $input: CreateAIChatPostInput!
    $condition: ModelAIChatPostConditionInput
  ) {
    createAIChatPost(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
      isGeneratedFileError
    }
  }
`;
export const updateAIChatPost = /* GraphQL */ `
  mutation UpdateAIChatPost(
    $input: UpdateAIChatPostInput!
    $condition: ModelAIChatPostConditionInput
  ) {
    updateAIChatPost(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
      isGeneratedFileError
    }
  }
`;
export const deleteAIChatPost = /* GraphQL */ `
  mutation DeleteAIChatPost(
    $input: DeleteAIChatPostInput!
    $condition: ModelAIChatPostConditionInput
  ) {
    deleteAIChatPost(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      postType
      chatThreadId
      role
      content
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      reasoning
      streamStatus
      isHasKboardScreenCapture
      isGeneratedFileError
    }
  }
`;
export const createAIChatThread = /* GraphQL */ `
  mutation CreateAIChatThread(
    $input: CreateAIChatThreadInput!
    $condition: ModelAIChatThreadConditionInput
  ) {
    createAIChatThread(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const updateAIChatThread = /* GraphQL */ `
  mutation UpdateAIChatThread(
    $input: UpdateAIChatThreadInput!
    $condition: ModelAIChatThreadConditionInput
  ) {
    updateAIChatThread(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const deleteAIChatThread = /* GraphQL */ `
  mutation DeleteAIChatThread(
    $input: DeleteAIChatThreadInput!
    $condition: ModelAIChatThreadConditionInput
  ) {
    deleteAIChatThread(input: $input, condition: $condition) {
      id
      corporationId
      affiliationProject
      chatThreadId
      optionSearch {
        methodSearch
        attributeSearch
        keywordList
        fromSearchDate
        toSearchDate
        formatSearch
        sortType
      }
      drillDownSearch {
        ticketType
        creator
        updator
        proxiedUser
        suffixOfAttachments
        form
        tagFields {
          fieldId
          fieldItemId
        }
        statusFields {
          fieldId
          fieldItemId
        }
        publicRange
        sharedBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
        privateBookmark {
          bookmarkId
          userSelectId
          projectSelectId
        }
      }
      clientUUId
      ticketId
      chatThreadType
      status
      metaData {
        filterKnowledgeListData
      }
      aiLogMetaData
      createdAt
      updatedAt
      startTime
      endTime
      creatorId
      updatorId
    }
  }
`;
export const createAttachFile = /* GraphQL */ `
  mutation CreateAttachFile(
    $input: CreateAttachFileInput!
    $condition: ModelAttachFileConditionInput
  ) {
    createAttachFile(input: $input, condition: $condition) {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const updateAttachFile = /* GraphQL */ `
  mutation UpdateAttachFile(
    $input: UpdateAttachFileInput!
    $condition: ModelAttachFileConditionInput
  ) {
    updateAttachFile(input: $input, condition: $condition) {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const deleteAttachFile = /* GraphQL */ `
  mutation DeleteAttachFile(
    $input: DeleteAttachFileInput!
    $condition: ModelAttachFileConditionInput
  ) {
    deleteAttachFile(input: $input, condition: $condition) {
      id
      shortKey
      attachBy
      relatedId
      originId
      affiliationOrganization
      affiliationProject
      s3Path
      fileInfo
      thumbnailInfo
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const createBookmark = /* GraphQL */ `
  mutation CreateBookmark(
    $input: CreateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    createBookmark(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const updateBookmark = /* GraphQL */ `
  mutation UpdateBookmark(
    $input: UpdateBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    updateBookmark(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const deleteBookmark = /* GraphQL */ `
  mutation DeleteBookmark(
    $input: DeleteBookmarkInput!
    $condition: ModelBookmarkConditionInput
  ) {
    deleteBookmark(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      name
      definition
      shareRange
      defaultBookmark
      creator
      createdAt
      updator
      updatedAt
      targetType
    }
  }
`;
export const createCallHistory = /* GraphQL */ `
  mutation CreateCallHistory(
    $input: CreateCallHistoryInput!
    $condition: ModelCallHistoryConditionInput
  ) {
    createCallHistory(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateCallHistory = /* GraphQL */ `
  mutation UpdateCallHistory(
    $input: UpdateCallHistoryInput!
    $condition: ModelCallHistoryConditionInput
  ) {
    updateCallHistory(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteCallHistory = /* GraphQL */ `
  mutation DeleteCallHistory(
    $input: DeleteCallHistoryInput!
    $condition: ModelCallHistoryConditionInput
  ) {
    deleteCallHistory(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      to
      callDirection
      callCategory
      metaData
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createChatPost = /* GraphQL */ `
  mutation CreateChatPost(
    $input: CreateChatPostInput!
    $condition: ModelChatPostConditionInput
  ) {
    createChatPost(input: $input, condition: $condition) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const updateChatPost = /* GraphQL */ `
  mutation UpdateChatPost(
    $input: UpdateChatPostInput!
    $condition: ModelChatPostConditionInput
  ) {
    updateChatPost(input: $input, condition: $condition) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const deleteChatPost = /* GraphQL */ `
  mutation DeleteChatPost(
    $input: DeleteChatPostInput!
    $condition: ModelChatPostConditionInput
  ) {
    deleteChatPost(input: $input, condition: $condition) {
      id
      ticketAffiliationOrganization
      ticketAffiliationProject
      corporationId
      affiliationProject
      postType
      chatThreadId
      content
      delegateUserId
      fileUrl
      fileSize
      thumbnailInfo
      status
      footPrint {
        userList
      }
      history {
        content
        updatedAt
        filesContent
      }
      mention
      reaction
      clientUUId
      seq
      createdAt
      updatedAt
      creatorId
      ticketId
      role
      emailId
      deliverStatus
      deliverAt
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
      transcriptItemId
      voiceTranscriptStatus
    }
  }
`;
export const createChatThread = /* GraphQL */ `
  mutation CreateChatThread(
    $input: CreateChatThreadInput!
    $condition: ModelChatThreadConditionInput
  ) {
    createChatThread(input: $input, condition: $condition) {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const updateChatThread = /* GraphQL */ `
  mutation UpdateChatThread(
    $input: UpdateChatThreadInput!
    $condition: ModelChatThreadConditionInput
  ) {
    updateChatThread(input: $input, condition: $condition) {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const deleteChatThread = /* GraphQL */ `
  mutation DeleteChatThread(
    $input: DeleteChatThreadInput!
    $condition: ModelChatThreadConditionInput
  ) {
    deleteChatThread(input: $input, condition: $condition) {
      id
      corporationId
      sharedRange
      editableRange
      ticketId
      aiAssistantTicketId
      threadType
      createdAt
      updatedAt
      creatorId
      affiliationProject
      chatThreadId
      clientUUId
      aiAssistantStatus
      aiAssistantStatusUpdatedAt
    }
  }
`;
export const createContract = /* GraphQL */ `
  mutation CreateContract(
    $input: CreateContractInput!
    $condition: ModelContractConditionInput
  ) {
    createContract(input: $input, condition: $condition) {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const updateContract = /* GraphQL */ `
  mutation UpdateContract(
    $input: UpdateContractInput!
    $condition: ModelContractConditionInput
  ) {
    updateContract(input: $input, condition: $condition) {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const deleteContract = /* GraphQL */ `
  mutation DeleteContract(
    $input: DeleteContractInput!
    $condition: ModelContractConditionInput
  ) {
    deleteContract(input: $input, condition: $condition) {
      id
      affiliationOrganization
      productId
      editionId
      versionId
      kind
      paymentStatus
      paymentMethod
      paymentCycle
      currentPaymentCycle
      paymentDate
      price
      contractStatus
      additionalUpgradeSetting
      additionalPrivateSetting
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      metaData
      trialDays
      startDate
      billStartDate
      billEndDate
      endTrialDate
      createdAt
      updatedAt
      creator
      updator
    }
  }
`;
export const createCorporation = /* GraphQL */ `
  mutation CreateCorporation(
    $input: CreateCorporationInput!
    $condition: ModelCorporationConditionInput
  ) {
    createCorporation(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const updateCorporation = /* GraphQL */ `
  mutation UpdateCorporation(
    $input: UpdateCorporationInput!
    $condition: ModelCorporationConditionInput
  ) {
    updateCorporation(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const deleteCorporation = /* GraphQL */ `
  mutation DeleteCorporation(
    $input: DeleteCorporationInput!
    $condition: ModelCorporationConditionInput
  ) {
    deleteCorporation(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      logoFileName
      active
      name
      languages
      autoTranslation
      organizationDomain
      contractType
      contractDate
      lastDayOfContract
      creditCard
      ZIPcode
      address
      mail
      tel
      departmentName
      activatedFunctions
      limitValue {
        maxNumOfGeneralUser
        numOfGeneralUser
        maxNumOfAgent
        numOfAgent
        maxNumOfGuestUser
        numOfGuestUser
        maxNumOfCustomer
        numOfCustomer
        maxNumOfGeneralProject
        numOfGeneralProject
        maxNumOfGuestProject
        numOfGuestProject
        maxNumOfGuestDesk
        numOfGuestDesk
        numOfTicket
        maxNumOfTicket
        numOfStorage
        maxNumOfStorage
        numOfInternalUser
        numOfB2CCustomer
        numOfProjectDeskOn
        numOfProjectPublicOn
        numOfTicketKnowledge
        internalQACounterSettings
        publicWebForm
        emailResponseFunction
        knowledgeBot
        synonymSearch
        batchCommandService
        convertPDF
        chatAI
        usingChatAI
        lincenseKeyPermission
        lincenseKeySetting
        lincenseKeyValue
        chatGPTModel
        knnValue
        minScore
        aiAuto
        sdAuto
        telephoneAgent
        fileTranslation
        kBoard
        mcpServer
        multiLanguage
        systemPrompt
        interatorSystemPrompt
        usingAIAuto
        usingSDAuto
        usingTelephoneAgent
        usingFileTranslation
        usingKBoard
        usingMultiLanguage
        advancedOptionSettings
        logAnalysis
        ipRestriction
        maxNumOfTicketKnowledge
        maxNumberOfFormat
        maxNumberOfQACounters
        maxNumberOfSupportedCounters
        maxNumOfInternalUser
        maxNumOfB2CCustomer
        numberOfFormat
        numberOfQACounters
        numberOfSupportedCounters
        storageVolume
        generalUserFee
        basicCharge
        taskManagement
        vectorTicketDataStatus
        deskService
        knowledgeService
        publicService
        publicServiceDeskSettings
        solutionsDeskOfKnowledge
        publicKnowledgeSite
        numOfUserInOrg
        numOfPartnerId
        externalWebAPI
        numberOfExternalAPICalls
        maxNumberOfExternalAPICalls
        usingMultiAuth
        multiAuth
        localMcpEnabled
      }
      inviter
      inviterOrganizationDomain
      corporationInvited
      creator
      createdAt
      updator
      updatedAt
      rootFlag
      owner
      deskService
      knowledgeService
      taskManagementService
      publicService
      metaData
      versionId
      contractId
      contractStatus
      corporationSetting
      limitSetting
      translationCacheResetAt
    }
  }
`;
export const createExternalAPI = /* GraphQL */ `
  mutation CreateExternalAPI(
    $input: CreateExternalAPIInput!
    $condition: ModelExternalAPIConditionInput
  ) {
    createExternalAPI(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const updateExternalAPI = /* GraphQL */ `
  mutation UpdateExternalAPI(
    $input: UpdateExternalAPIInput!
    $condition: ModelExternalAPIConditionInput
  ) {
    updateExternalAPI(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const deleteExternalAPI = /* GraphQL */ `
  mutation DeleteExternalAPI(
    $input: DeleteExternalAPIInput!
    $condition: ModelExternalAPIConditionInput
  ) {
    deleteExternalAPI(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      ownerBy
      connectId
      serviceName
      baseURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      baseSetting {
        userName
        password
        apiKeyValue
        metaData
      }
      apiOverview
      inputParamDesc
      outputFormat
      testURL
      testParam
      testResult
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const createForms = /* GraphQL */ `
  mutation CreateForms(
    $input: CreateFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    createForms(input: $input, condition: $condition) {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const updateForms = /* GraphQL */ `
  mutation UpdateForms(
    $input: UpdateFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    updateForms(input: $input, condition: $condition) {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const deleteForms = /* GraphQL */ `
  mutation DeleteForms(
    $input: DeleteFormsInput!
    $condition: ModelFormsConditionInput
  ) {
    deleteForms(input: $input, condition: $condition) {
      id
      usage
      name
      affiliationOrganization
      affiliationProject
      affiliationField
      createdAt
      updatedAt
      multiActionTime
      creator
      updator
      type
      structure
      viewForCustomer
      definition
      explanation
      usingProjects
      usingTickets
      order
      hasValue
      usingForms
      hitNumber
      sysField
      relatedMasterForm
      settingAutoAdd
      sharedFormList
      sharedFieldList
      shareRange
      shareOption
      viewPermission
      editPermission
      chatPermission
      createTicketForOwnerPermission
      additionalCreateTicketForOwnerPermission
      reviewFlag
      usingTicket
      usedProject
      promptKnowledgeFormFlag
      isSynonym
      definitionVariant
      isAllowCustomerChangeStatus
      hideInProject
      autoTranslateAttachment
      translateSourceLang
      translateTargetLangs
    }
  }
`;
export const createMCPCatalog = /* GraphQL */ `
  mutation CreateMCPCatalog(
    $input: CreateMCPCatalogInput!
    $condition: ModelMCPCatalogConditionInput
  ) {
    createMCPCatalog(input: $input, condition: $condition) {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateMCPCatalog = /* GraphQL */ `
  mutation UpdateMCPCatalog(
    $input: UpdateMCPCatalogInput!
    $condition: ModelMCPCatalogConditionInput
  ) {
    updateMCPCatalog(input: $input, condition: $condition) {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteMCPCatalog = /* GraphQL */ `
  mutation DeleteMCPCatalog(
    $input: DeleteMCPCatalogInput!
    $condition: ModelMCPCatalogConditionInput
  ) {
    deleteMCPCatalog(input: $input, condition: $condition) {
      id
      usage
      parentId
      version
      mcpName
      mcpPackageName
      mcpPackageVersion
      mcpType
      mcpStatus
      description
      purpose
      supportedOS
      downloadURL
      prerequisites
      systemPrompt
      releaseNotes
      requiredEnv
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createMCPServer = /* GraphQL */ `
  mutation CreateMCPServer(
    $input: CreateMCPServerInput!
    $condition: ModelMCPServerConditionInput
  ) {
    createMCPServer(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const updateMCPServer = /* GraphQL */ `
  mutation UpdateMCPServer(
    $input: UpdateMCPServerInput!
    $condition: ModelMCPServerConditionInput
  ) {
    updateMCPServer(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const deleteMCPServer = /* GraphQL */ `
  mutation DeleteMCPServer(
    $input: DeleteMCPServerInput!
    $condition: ModelMCPServerConditionInput
  ) {
    deleteMCPServer(input: $input, condition: $condition) {
      id
      affiliationOrganization
      affiliationProject
      type
      openaiConnectorId
      connectId
      serverName
      serverURL
      authMethod
      status
      oauth2Setting {
        clientId
        secret
        scope
        authUrl
        tokenUrl
        accessToken
        refreshToken
        gasProjectId
        redirectUrl
        resultResponse
      }
      jwtSetting {
        iss
        sub
        aud
        privateKey
        scope
        exp
        accessToken
      }
      bearerSetting {
        bearer
        metaData
      }
      apiKeySetting {
        apiKey
        metaData
      }
      memo
      isActiveCorp
      projectActived
      ownerBy
      creator
      createdAt
      updator
      updatedAt
      deletedAt
      lastTestedAt
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      systemType
      affiliationOrganization
      affiliationProject
      notificationRange
      sourceObject
      objectType
      eventType
      sourceInfo
      footPrint
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      productId
      editionId
      name
      order
      metaData
      increaseRate
      usage
      status
      isTrial
      moduleSetting
      creator
      createdAt
      updator
      aiBasicPrompt
      updatedAt
      deletedAt
    }
  }
`;
export const createProject = /* GraphQL */ `
  mutation CreateProject(
    $input: CreateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    createProject(input: $input, condition: $condition) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateProject = /* GraphQL */ `
  mutation UpdateProject(
    $input: UpdateProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    updateProject(input: $input, condition: $condition) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteProject = /* GraphQL */ `
  mutation DeleteProject(
    $input: DeleteProjectInput!
    $condition: ModelProjectConditionInput
  ) {
    deleteProject(input: $input, condition: $condition) {
      id
      projectId
      usage
      affiliationOrganization
      image
      active
      name
      languages
      autoTranslation
      id2
      privilege
      type
      mail
      tel
      projectInvite
      projectInvited
      iframeSetting
      chatbotSetting
      isDesk
      isPublic
      isGuest
      publicKnowledgeSiteSetting
      projectAlias
      projectSetting
      mcpTunnelId
      chatBotCategorySetting
      mailSetting
      userLogCache
      managementPanel
      phoneAvailability
      lastUpdatePhoneAvailability
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createQueue = /* GraphQL */ `
  mutation CreateQueue(
    $input: CreateQueueInput!
    $condition: ModelQueueConditionInput
  ) {
    createQueue(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const updateQueue = /* GraphQL */ `
  mutation UpdateQueue(
    $input: UpdateQueueInput!
    $condition: ModelQueueConditionInput
  ) {
    updateQueue(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const deleteQueue = /* GraphQL */ `
  mutation DeleteQueue(
    $input: DeleteQueueInput!
    $condition: ModelQueueConditionInput
  ) {
    deleteQueue(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      planTime
      executeTime
      createdAt
      updatedAt
    }
  }
`;
export const createSdeskToken = /* GraphQL */ `
  mutation CreateSdeskToken(
    $input: CreateSdeskTokenInput!
    $condition: ModelSdeskTokenConditionInput
  ) {
    createSdeskToken(input: $input, condition: $condition) {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateSdeskToken = /* GraphQL */ `
  mutation UpdateSdeskToken(
    $input: UpdateSdeskTokenInput!
    $condition: ModelSdeskTokenConditionInput
  ) {
    updateSdeskToken(input: $input, condition: $condition) {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteSdeskToken = /* GraphQL */ `
  mutation DeleteSdeskToken(
    $input: DeleteSdeskTokenInput!
    $condition: ModelSdeskTokenConditionInput
  ) {
    deleteSdeskToken(input: $input, condition: $condition) {
      id
      tokenHash
      tokenType
      userId
      affiliationOrganization
      affiliationProject
      scopes
      status
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createShareLink = /* GraphQL */ `
  mutation CreateShareLink(
    $input: CreateShareLinkInput!
    $condition: ModelShareLinkConditionInput
  ) {
    createShareLink(input: $input, condition: $condition) {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const updateShareLink = /* GraphQL */ `
  mutation UpdateShareLink(
    $input: UpdateShareLinkInput!
    $condition: ModelShareLinkConditionInput
  ) {
    updateShareLink(input: $input, condition: $condition) {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const deleteShareLink = /* GraphQL */ `
  mutation DeleteShareLink(
    $input: DeleteShareLinkInput!
    $condition: ModelShareLinkConditionInput
  ) {
    deleteShareLink(input: $input, condition: $condition) {
      id
      shortKey
      targetId
      type
      targetAffiliationCorporationId
      targetAffiliationCorporationDomain
      targetAffiliationProjectId
      generateLinkCorporationId
      generateLinkCorporationDomain
      generateLinkProjectId
      createdAt
      updatedAt
    }
  }
`;
export const createTask = /* GraphQL */ `
  mutation CreateTask(
    $input: CreateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    createTask(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const updateTask = /* GraphQL */ `
  mutation UpdateTask(
    $input: UpdateTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    updateTask(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const deleteTask = /* GraphQL */ `
  mutation DeleteTask(
    $input: DeleteTaskInput!
    $condition: ModelTaskConditionInput
  ) {
    deleteTask(input: $input, condition: $condition) {
      id
      usage
      type
      status
      retry
      info
      taskId
      createdBy
      createdAt
      updatedAt
    }
  }
`;
export const createTicket = /* GraphQL */ `
  mutation CreateTicket(
    $input: CreateTicketInput!
    $condition: ModelTicketConditionInput
  ) {
    createTicket(input: $input, condition: $condition) {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const updateTicket = /* GraphQL */ `
  mutation UpdateTicket(
    $input: UpdateTicketInput!
    $condition: ModelTicketConditionInput
  ) {
    updateTicket(input: $input, condition: $condition) {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const deleteTicket = /* GraphQL */ `
  mutation DeleteTicket(
    $input: DeleteTicketInput!
    $condition: ModelTicketConditionInput
  ) {
    deleteTicket(input: $input, condition: $condition) {
      id
      ticketId
      dataType
      dataID
      dataLang
      dataValue
      usage
      formId
      affiliationOrganization
      affiliationProject
      customer
      readPermission
      additionalReadPermission
      writePermission
      additionalWritePermission
      createdAt
      updatedAt
      creator
      updator
      proxiedUser
      proxyCreator
      liveOrArchived
      chatThreadWithCustomer
      chatThreadInProject
      aiAssistantChatThread
      inhouseCollaboratorTicketId
      inhouseCustomerTicketId
      externalCollaboratorTicketId
      externalCustomerTicketId
      public
      customersCustomer
      parent
      children
      projectOrigin
      projectTarget
      invitationFlag
      invitationInfo {
        adminEmail
        adminFirstName
        adminLastName
        orgName
        projectName
        projectInvite
        projectType
        customerEmail
        customerLastName
        customerFirstName
        linkInvite
        guestContractRegister {
          id
          mailAddress
          userId
          firstName
          lastName
          corporationPhone
          corporationName
          departmentName
          subDomain
          password
          contractType
          inviter
          userType
          projectType
          projectName
          ticketId
          projectInvite
        }
        expireAt
        maxGeneralId
        numberGeneralIdLeft
        subDomainInvited
      }
      approveFlag
      bookmark
      ticketType
      deadLine
      personInCharge
      status
      telephoneStatus
      followUpRootTicketId
      sprint
      priority
      processingOrder
      approvePageLink {
        link
        expireTime
      }
      publicType
      publicRange
      lastMessage
      anonymousUserInfo
      anonymousQaStatus
      updatedForCustomer
      updatedForDesk
      footPrint
      viewPermission
      additionalViewPermission
      editPermission
      additionalEditPermission
      chatPermission
      deletedAt
      timeVectorInfo
      promptFlag
      contentPagePdf
      totalToken
      isSynonym
      metaData
      promptData
      deliverStatus
      deliverInfo {
        status
        deliverAt
        sender
        __typename
      }
    }
  }
`;
export const createTranslationDictionary = /* GraphQL */ `
  mutation CreateTranslationDictionary(
    $input: CreateTranslationDictionaryInput!
    $condition: ModelTranslationDictionaryConditionInput
  ) {
    createTranslationDictionary(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateTranslationDictionary = /* GraphQL */ `
  mutation UpdateTranslationDictionary(
    $input: UpdateTranslationDictionaryInput!
    $condition: ModelTranslationDictionaryConditionInput
  ) {
    updateTranslationDictionary(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteTranslationDictionary = /* GraphQL */ `
  mutation DeleteTranslationDictionary(
    $input: DeleteTranslationDictionaryInput!
    $condition: ModelTranslationDictionaryConditionInput
  ) {
    deleteTranslationDictionary(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      sourceLanguage
      targetLanguage
      status
      translationEngine
      sourceText
      sourceHash
      translatedText
      category
      useAsTerminology
      isUserDefined
      entryId
      translateId
      sourceType
      sourceId
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createTranslationJob = /* GraphQL */ `
  mutation CreateTranslationJob(
    $input: CreateTranslationJobInput!
    $condition: ModelTranslationJobConditionInput
  ) {
    createTranslationJob(input: $input, condition: $condition) {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateTranslationJob = /* GraphQL */ `
  mutation UpdateTranslationJob(
    $input: UpdateTranslationJobInput!
    $condition: ModelTranslationJobConditionInput
  ) {
    updateTranslationJob(input: $input, condition: $condition) {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteTranslationJob = /* GraphQL */ `
  mutation DeleteTranslationJob(
    $input: DeleteTranslationJobInput!
    $condition: ModelTranslationJobConditionInput
  ) {
    deleteTranslationJob(input: $input, condition: $condition) {
      id
      shortKey
      affiliationOrganization
      affiliationProject
      sourceUrl
      sourceType
      shareLink
      sourceS3Url
      sourceS3UrlHash
      attachShareLink
      sourceFileName
      sourceMimeType
      sourceFileSize
      sourceLang
      detectedSourceLang
      targetLangs
      status
      operationName
      inputGcsPath
      outputGcsPrefix
      attachContentUrl
      results
      fileType
      pageCount
      charCount
      errorMessage
      aiChatThreadId
      requestSource
      invalidatedAt
      googleMetaData
      billingOrganization
      billingProject
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createTranslationUsage = /* GraphQL */ `
  mutation CreateTranslationUsage(
    $input: CreateTranslationUsageInput!
    $condition: ModelTranslationUsageConditionInput
  ) {
    createTranslationUsage(input: $input, condition: $condition) {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const updateTranslationUsage = /* GraphQL */ `
  mutation UpdateTranslationUsage(
    $input: UpdateTranslationUsageInput!
    $condition: ModelTranslationUsageConditionInput
  ) {
    updateTranslationUsage(input: $input, condition: $condition) {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const deleteTranslationUsage = /* GraphQL */ `
  mutation DeleteTranslationUsage(
    $input: DeleteTranslationUsageInput!
    $condition: ModelTranslationUsageConditionInput
  ) {
    deleteTranslationUsage(input: $input, condition: $condition) {
      id
      affiliationOrganization
      yearMonth
      pageCount
      charCount
      onDemandChar
      jobCount
      billablePages
      billableChars
      creator
      createdAt
      updatedAt
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      usage
      affiliationOrganization
      image
      active
      firstName
      middleName
      lastName
      languages
      privilege
      type
      mail
      tel
      agent
      projectInuse
      readNotificationAt
      workSpace
      creator
      createdAt
      updator
      updatedAt
      expireAt
      forgotPasswordSessionExpireAt
      settingNotification
      isGuest
      userSetting
      mcpTunnelSetting
      mcpTunnelId
      projectRejected
      workLastForm
      organizationName
    }
  }
`;
export const createUserBookmark = /* GraphQL */ `
  mutation CreateUserBookmark(
    $input: CreateUserBookmarkInput!
    $condition: ModelUserBookmarkConditionInput
  ) {
    createUserBookmark(input: $input, condition: $condition) {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const updateUserBookmark = /* GraphQL */ `
  mutation UpdateUserBookmark(
    $input: UpdateUserBookmarkInput!
    $condition: ModelUserBookmarkConditionInput
  ) {
    updateUserBookmark(input: $input, condition: $condition) {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const deleteUserBookmark = /* GraphQL */ `
  mutation DeleteUserBookmark(
    $input: DeleteUserBookmarkInput!
    $condition: ModelUserBookmarkConditionInput
  ) {
    deleteUserBookmark(input: $input, condition: $condition) {
      id
      userId
      bookmarkId
      ticketId
      projectSetting
      bookmarkShareRange
      bookmarkAffiliationProject
      ticketAffiliationProject
      ticketAffiliationOrganization
      creator
      createdAt
      updator
      updatedAt
    }
  }
`;
export const createView = /* GraphQL */ `
  mutation CreateView(
    $input: CreateViewInput!
    $condition: ModelViewConditionInput
  ) {
    createView(input: $input, condition: $condition) {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const updateView = /* GraphQL */ `
  mutation UpdateView(
    $input: UpdateViewInput!
    $condition: ModelViewConditionInput
  ) {
    updateView(input: $input, condition: $condition) {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
export const deleteView = /* GraphQL */ `
  mutation DeleteView(
    $input: DeleteViewInput!
    $condition: ModelViewConditionInput
  ) {
    deleteView(input: $input, condition: $condition) {
      id
      name
      affiliationOrganization
      affiliationProject
      affiliationView
      visibleRange
      visibleType
      structure
      viewType
      definitionView
      status
      order
      sortData
      creator
      updator
      createdAt
      updatedAt
    }
  }
`;
